export const BRANDS = {
  JUVELOOK: "JUVELOOK",
  LENISNA: "LENISNA",
  RENEE: "RENEE",
  KSURGERY: "KSURGERY",
  ELLANSE:"ELLANSE",
  LANLUMA:"LANLUMA",
  MAILI:"MAILI",
  DIMONO:"DIMONO",
  DRCYJ:"DRCYJ"
};
